<p-panel [toggleable]="true">
  <p-header>
    <label i18n="@@labelText42">Principal</label>
  </p-header>
  <div class="ui-g">
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText43">Código</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ osS.codigo }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText44">Microárea</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 ui-fluid">{{ osS.codigoNode }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText45">Tipo OS</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.resumoTipoOSAux }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText46">Data de Abertura</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.dataSolicitacao | date: constants.dateFormat}}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText47">Data Agendada</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.dataDisponibilidade }} </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText48">Prazo Máximo de Atendimento</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.dataMaxAtendimento | date: constants.dateFormat }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText49">Hora Entrada</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.horaEntrada | date: constants.hourFormat }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText50">Hora Saída</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.horaSaida | date: constants.hourFormat }}</div>
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText51">Motivo</label>
    </div>
    <div class="ui-md-3 ui-sm-6 ui-g-6">{{ osS.descricaoMotivoStatus }}</div>
  </div>
</p-panel>
<p-panel [toggleable]="true">
  <p-header>
    <label i18n="@@labelText52">Endereço</label>
  </p-header>
  <div class="ui-g">
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText53">Endereço Completo</label>
    </div>
    <div class="ui-md-5 ui-sm-6 ui-g-6 ">{{ osS.enderecoCompleto }}</div>
  </div>
</p-panel>
<p-panel [toggleable]="true">
  <p-header>
    <label i18n="@@labelText84">Ambientes</label>
  </p-header>
  <span *ngFor="let a of osS.osAmbientes" style="margin-right: 10px">
  <div class="ui-g">
    <div class="ui-md-3 ui-sm-6 ui-g-6 label-os">
      <label i18n="@@labelText85">Descrição</label>
    </div>
    <div class="ui-md-5 ui-sm-6 ui-g-6 ">{{a.descricao}}</div>
  </div>
  </span>
</p-panel>
<p-panel [toggleable]="true" class="isClosed">
  <p-header>
    <label i18n="@@labelText54">Check List</label>
  </p-header>
  <div class="ui-g">
    <p-table class="search-results" [value]="checklist" responsive="true">

      <ng-template pTemplate="header">
        <tr>
          <th class="col-header-id">
            <label i18n="@@labelText55">Pergunta</label>
          </th>
          <th>
            <label i18n="@@labelText56">Resposta</label>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-chk>
        <tr>
          <td>
            {{ chk.pergunta }}
          </td>
          <td>
            {{ chk.resposta }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-panel>

<p-panel [toggleable]="true" class="isClosed">
  <p-header>
    <label i18n="@@labelText57">Estoque</label>
  </p-header>
  <div class="ui-g">
    <p-table class="search-results" [value]="material" responsive="true">
      <ng-template pTemplate="caption">
        <label i18n="@@labelText58" >Material</label>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="col-header-id">
            <label i18n="@@labelText59">Código</label>
          </th>
          <th>
            <label i18n="@@labelText60">Descrição</label>
          </th>
          <th>
            <label i18n="@@labelText61">Unidade de Medida</label>
          </th>
          <th>
            <label i18n="@@labelText62">Quantidade</label>
          </th>
          <th>
            <label i18n="@@labelText63">Valor</label>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-mat>
        <tr>
          <td>
            {{ mat.materialOut.codigoMaterial }}
          </td>
          <td>
            {{ mat.materialOut.descricaoMaterial }}
          </td>
          <td>
            {{ mat.unidadeMedida }}
          </td>
          <td>
            {{ mat.qtd }}
          </td>
          <td>
            {{ mat.valorTotal }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="ui-g">
    <p-table class="search-results" [value]="ativo" responsive="true">
      <ng-template pTemplate="caption">
        <label i18n="@@labelText64" >Ativo</label>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="col-header-id">
            <label i18n="@@labelText65">Número de Série</label>
          </th>
          <th>
            <label i18n="@@labelText66">Número do Patrimônio</label>
          </th>
          <th>
            <label i18n="@@labelText67">Descrição</label>
          </th>
          <th>
            <label i18n="@@labelText68">Status</label>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-atv>
        <tr>
          <td>
            {{ atv.numeroSerie }}
          </td>
          <td>
            {{ atv.numeroPatrimonio }}
          </td>
          <td>
            {{ atv.descricao }}
          </td>
          <td>
            {{ atv.acao }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-panel>
<p-panel [toggleable]="true">
  <p-header>
    <label i18n="@@labelText69">Anexos</label>
  </p-header>
  <div class="ui-g">
    <p-table class="search-results" [value]="anexo" responsive="true">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-header-id">
            <label i18n="@@labelText73">Nome Publicado</label>
          </th>
          <th class="col-header-id">
            <label i18n="@@labelText72">Observações</label>
          </th>
          <th>
            <label i18n="@@labelText71">Visualizar</label>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-anx>
        <tr>
          <td>
            {{ anx.nomeArquivo }}
          </td>
          <td>
            {{ anx.observacao }}
          </td>
          <td>
            <label class="iconTable"><label class="fas fa-external-link-alt" (click)="showDialog(anx)"></label></label>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-panel>
